export const PROJECT_STATUS = [
    "Awaiting Inspection",
    "Materials Ordered",
    "Awaiting Install",
    "Day of Install",
    "Project Complete",
];
